module.exports = __webpack_public_path__ + "6a1f07e9bbce0fa95e5eff96a61b15e2.fbx";